module.exports = __webpack_public_path__ + "static/media/compdata-logo.af1fe155.png";